import '@adornis/file-utils/db/index.js';
import './ContactRequest.js';
import './api/index.js';

import './_buildify/wiki/entities/WikiEntry.js';
import './api/DocumentationAPI.js';
import './campus-learning-content/api/LearningDataAPI.js';
import './comments/index.js';
import './master-data-management/partner/index.js';
import './reporting/index.js';
import './workshops/index.js';

import '@adornis/field-management/field-configuration.js';

import './CRMFlags.js';
import './CampusMails.js';
import './CampusUserGroup.js';
import './DocxTemplate.js';
import './duplicates/DuplicateDataTracker.js';
import './Holiday.js';
import './LogistikCart.js';
import './LogistikClearanceSettings.js';
import './LogistikInfoMail.js';
import './LogistikOrder.js';
import './LogistikProduct.js';
import './LogistikProductFilter.js';
import './LogistikProductOrdering.js';
import './OrAspect.js';
import './PresenceRecord.js';
import './ProductIdea.js';
import './RegisterEventlog.js';
import './ScopedEntity.js';
import './Scopes.js';
import './StudentsReport.js';
import './capacity/index.js';
import './counters.js';
import './softgarden/SoftgardenImportRecord.js';
import './epub/entities/ebook-file.js';

// Courses
import './courses/Course.js';
import './courses/CourseAbschluss.js';
import './courses/CourseChancenschule.js';
import './courses/CourseDigital.js';
import './courses/CourseExamPreparation.js';
import './courses/CourseGraduation.js';
import './courses/CourseIntensive.js';
import './courses/CourseIntensiveSingle.js';
import './courses/CourseLUS.js';
import './courses/CourseLernfoerderung.js';

import '@chancenwerk/enums/enums.js';
import './HefteTeacherActivationCode.js';
import './dataTransferObjects/CRMActionResponse.js';
import './dataTransferObjects/FundingCreationInformation.js';
import './eventlogs/AnmeldungConversionEventlog.js';
import './eventlogs/AttendanceExportEventlog.js';
import './eventlogs/ChancenKurveEventlog.js';
import './eventlogs/ChancencornerLessonFinishedEventlog.js';
import './eventlogs/ContentResultEventlog.js';
import './eventlogs/GuestDayEventlog.js';
import './eventlogs/MailEventlog.js';
import './eventlogs/PageLoadEventlog.js';
import './eventlogs/XAPIEventlog.js';
import './filter/StudentFilter.js';
import './import-export/employees.js';
import './import-export/student.js';
import './notifications/CampusNotification.js';
import './notifications/ChancenNotification.js';
import './semantics/ChancenRole.js';
import './semantics/ChancenRoleAspect.js';
import './semantics/ChancenRoleMultiAspect.js';
import './semantics/ExternalKPFRelationship.js';
import './semantics/PartnerRelationship.js';
import './semantics/SemanticRelationship.js';
import './semantics/StudentParticipationRelationship.js';
import './semantics/Taetigkeit.js';
import './tokens.js';
import '@adornis/versioned-entity/api/index.js';

import './AcquisitionRecord.js';

import '@adornis/analytics/db/index.js';
import '@adornis/buildify/db/index.js';
import '@adornis/data-view/db/export-data-view.js';
import '@adornis/filter/get-standard-filter-operation.js';

import '@adornis/duplicate-merger/db/index.js';
import '@adornis/file-utils/db/index.js';
import '@adornis/filter/filter-options.js';
import '@adornis/import-export/db/export-job.js';
import '@adornis/import-export/db/import-job.js';
import '@adornis/print/db/print.js';
import '@adornis/todo/db/index.js';

//TODO: fix paths to new path inside db package
// Import chancenwerk specific baseql definitions
import '@chancenwerk/family/index.js';
import '@chancenwerk/release-notes/index.js';
import './_buildify/index.js';
import './_cms/index.js';
import './attendance/index.js';
import './campus-learning-content/index.js';
import './funding/index.js';
import './kpi/index.js';
import './master-data-management/index.js';
import './master-data-management/secure-access/index.js';
import './public-access/index.js';

// Wiki
import '@adornis/mails/db/mail-template.js';
import '@adornis/view-manager/db/index.js';
import '@adornis/wiki/api/index.js';
import '@adornis/wiki/db/index.js';
import './user-configs/index.js';
